import { BASKET_TYPES, selectBasketDeliveries, selectBasketList, selectBasketToPay } from 'containers/OrderDetails/basketSlice'
import { useReduxSelector } from 'store'

const useGroupedBasket = (
  skipAddons = true,
  generateDeliveryPriceList = true
) => {
  const deliveries = useReduxSelector(selectBasketDeliveries)
  const toPay = useReduxSelector(selectBasketToPay)
  const list = useReduxSelector(selectBasketList)

  const groupBasketListByType = () => {
    const betterList = []
    const deliveriesObject = generateDeliveryPriceList
      ? deliveries.reduce((r, delivery) => {
        r[delivery.id] = delivery
        return r
      }, {})
      : {}
    const additionalCartItemList = generateDeliveryPriceList
      ? list.map(item => toPay && toPay[item.identifier]
        ? { ...item, externalDeliveryId: toPay[item.identifier].deliveryId }
        : item)
      : []

    list.forEach((item, idx) => {
      if (item.type === BASKET_TYPES.rent) {
        const { placeLocks, warehouseLocks, deliveries } = list.reduce((r, l) => {
          const isValid = l.type === 'rentAddon' && (
            l.ownerId
              ? l.ownerId === item.identifier
              : l.related
                ? (l.related.some(r => r.cartId === item.identifier || r.id === item.placeId))
                : l.placeId === item.placeId)
          if (isValid) {
            if (l.ownerId || l.related?.some(r => r.cartId === item.identifier)) {
              r.warehouseLocks.push(l)
            }
            if ((!l.ownerId && !l.related) || l.related?.some(r => r.object === 'Place' && r.id === item.placeId)) {
              r.placeLocks.push(l)
            }

            const externalDeliveryId = toPay?.[l.identifier]?.deliveryId
            const showDeliveryPrice = toPay && externalDeliveryId && generateDeliveryPriceList
              ? additionalCartItemList.find(i => i.externalDeliveryId === externalDeliveryId)?.identifier === l.identifier
              : false
            if (showDeliveryPrice) {
              r.deliveries.push({ ...item, index: idx, externalDeliveryId, deliveryType: deliveriesObject?.[l.deliveryId]?.type })
            }
          }
          return r
        }, {
          placeLocks: [],
          warehouseLocks: [],
          deliveries: []
        })
        betterList.push({ ...item, index: idx, placeLocks, warehouseLocks, deliveries })

      } else if (item.type === BASKET_TYPES.shop || !skipAddons) {
        const externalDeliveryId = toPay?.[item.identifier]?.deliveryId
        const showDeliveryPrice = toPay && externalDeliveryId && generateDeliveryPriceList
          ? additionalCartItemList.find(i => i.externalDeliveryId === externalDeliveryId)?.identifier === item.identifier
          : false
        if (showDeliveryPrice) {
          betterList.push({ ...item, index: idx, externalDeliveryId, deliveryType: deliveriesObject?.[item.deliveryId]?.type })
        } else {
          betterList.push({ ...item, index: idx })
        }
      }
    })

    return betterList
  }

  return (list && list.length > 0)
    ? groupBasketListByType()
    : []
}

export default useGroupedBasket